require("!!C:\\Users\\max.guglielmi\\Documents\\dev\\perso\\javascript\\GitHub\\TableFilter\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\max.guglielmi\\Documents\\dev\\perso\\javascript\\GitHub\\TableFilter\\node_modules\\script-loader\\node_modules\\raw-loader\\index.js!C:\\Users\\max.guglielmi\\Documents\\dev\\perso\\javascript\\GitHub\\TableFilter\\libs\\sortabletable.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./libs/sortabletable.js
// module id = 443
// module chunks = 1